<ng-template #deleteConfirmationModal let-c="close">
    <form #deleteConfirmationForm="ngForm" [class.submitted]="deleteConfirmationForm.submitted" (ngSubmit)="submit(deleteConfirmationForm)" novalidate>
        <div class="modal-header">
            <div class="modal-title"><span class="bold">Confirm</span> Deletion</div>
            <button type="button" class="rms-sheet-close" aria-label="Close" (click)="c()">&times;</button>
        </div>
        <div class="modal-body">
            <div *ngIf="isTradeRestriction">
                <div>Removing {{ data.restrictionName }}</div>
                <div class="form-group">
                    <label for="removalReason">Reason for Removal<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="removalReasonRef" [componentForm]="deleteConfirmationForm"></rms-required-label>
                    </label>
                    <textarea id="removalReason" name="removalReason" class="form-control" [(ngModel)]="removalReason" rows="2" #removalReasonRef="ngModel" required></textarea>
                </div>
            </div>
            <div class="form-group date-input-group">
                <label for="boardSeatEndDate">End Date</label>
                <div class="input-group">
                    <rms-date-picker id="boardSeatEndDate"
                                name="boardSeatEndDate"
                                #boardSeatEndDate="ngModel"
                                [(ngModel)]="endDate"
                                [isRange]="false"
                                [min]="data.startDate"
                                [max]="maxEndDate"
                                [required]="true">
                    </rms-date-picker>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="rms-sheet-eze" *ngIf="!environment.production">
                <input id="force-eze-error" name="force-eze-error" type="checkbox" [(ngModel)]="forceEzeError" />
                <label for="force-eze-error">Force Eze Error</label>
            </div>
            <button type="button" class="btn btn-outline-teal" (click)="c()">{{ "GENERICS.CANCEL" | translate }}</button>
            <button type="submit" class="btn btn-teal" [disabled]="deleteConfirmationForm.invalid">{{ isTradeRestriction ? 'Submit' : 'Confirm'}}</button>
        </div>
    </form>
</ng-template>
